import { render, staticRenderFns } from "./DashboardRecords.vue?vue&type=template&id=27119ddc"
import script from "./DashboardRecords.vue?vue&type=script&lang=js"
export * from "./DashboardRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports